module.exports = __webpack_public_path__ + "img/chinesecompany106.480b365d.png";